/* FTP Welcome Kit guard.
   29 Aug 2026: caps each free Welcome Kit gift line at 1.
   29 Sep 2026: gifts are also removed from the cart whenever there is no
   Power Endurance System SUBSCRIPTION line in it (stops people removing the
   PES and checking out with the free kit). The offer page adds the PES and the
   kit in a single request, so a genuine subscriber never sees this fire.
   If the gift variants or the PES product ever change, update GIFT / PES below.
   9 Oct 2026: the welcome game ladder also adds £0 gift lines (pouch / electrolyte tube) carrying the line
   property _ftp_gift. Those are allowed without a PES subscription (the game script adds and removes them
   against the basket), still capped at 1, and labelled "Free welcome game gift". */
(function () {
  var GIFT = [57198398112070, 57198398144838, 57198398177606, 57198398210374, 57557084176710]; // pouch, bottle, TC taster, MF taster, electrolyte tube
  var PES = 15696017326406; // Power Endurance System product id
  var MAX = 1;
  var busy = false;
  var lastPes = null;

  function isGift(id) {
    return GIFT.indexOf(parseInt(id, 10)) !== -1;
  }

  function isGameGift(i) {
    return false; // 9 Oct late: the game no longer gives free gifts, so no exemption (any old game gift lines are removed)
  }

  function hasPesSubscription(items) {
    return items.some(function (i) {
      return parseInt(i.product_id, 10) === PES && !!i.selling_plan_allocation;
    });
  }

  function post(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  // Ask the server what is actually in the cart and fix any gift lines.
  // Resolves to 'removed', 'clamped' or false.
  function reconcile() {
    if (busy) return Promise.resolve(false);
    busy = true;
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var allowed = hasPesSubscription(items);
        lastPes = allowed;
        var game = items.filter(function (i) { return isGift(i.variant_id) && isGameGift(i); });
        var gifts = items.filter(function (i) { return isGift(i.variant_id) && !isGameGift(i); });
        var todo = game.filter(function (i) { return i.quantity > MAX; }).map(function (i) { return [i.key, MAX]; });
        todo = todo.concat(allowed
          ? gifts.filter(function (i) { return i.quantity > MAX; }).map(function (i) { return [i.key, MAX]; })
          : gifts.map(function (i) { return [i.key, 0]; }));
        if (!todo.length) { busy = false; return false; }
        var removing = todo.some(function (t) { return t[1] === 0; });
        return todo.reduce(function (chain, t) {
          return chain.then(function () { return post(t[0], t[1]); });
        }, Promise.resolve()).then(function () { busy = false; return removing ? 'removed' : 'clamped'; });
      })
      .catch(function () { busy = false; return false; });
  }

  function reconcileThenRefresh() {
    reconcile().then(function (changed) {
      if (!changed) { lockUI(); return; }
      var onCart = document.body.className.indexOf('template-cart') !== -1;
      if (onCart || changed === 'removed') {
        window.location.reload();
      } else {
        lockUI();
      }
    });
  }

  // 1. Clamp gift quantities on the way in (AJAX adds).
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      try {
        if (url.indexOf('/cart/add') !== -1 && init && typeof init.body === 'string') {
          var payload = JSON.parse(init.body);
          if (payload && payload.items && payload.items.length) {
            payload.items.forEach(function (i) {
              if (isGift(i.id) && i.quantity > MAX) i.quantity = MAX;
            });
            init.body = JSON.stringify(payload);
          } else if (payload && isGift(payload.id) && payload.quantity > MAX) {
            payload.quantity = MAX;
            init.body = JSON.stringify(payload);
          }
        }
      } catch (e) {}
      var result = originalFetch.apply(this, arguments);
      if (url.indexOf('/cart/') !== -1 && result && result.then) {
        result.then(function () { setTimeout(reconcileThenRefresh, 250); }).catch(function () {});
      }
      return result;
    };
  }

  // 2. Same safety net for jQuery / XHR cart updates.
  var originalSend = XMLHttpRequest.prototype.send;
  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._ftpCartCall = typeof url === 'string' && url.indexOf('/cart/') !== -1;
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._ftpCartCall) {
      this.addEventListener('load', function () { setTimeout(reconcileThenRefresh, 250); });
    }
    return originalSend.apply(this, arguments);
  };

  // 3. Grey out the quantity stepper on gift lines so it is clear they are fixed.
  function lockUI() {
    if (lastPes === null) return; // wait until we know which kind of gift it is
    var candidates = document.querySelectorAll('tr, li, div[class*="cart-item"], div[class*="cart__item"]');
    Array.prototype.forEach.call(candidates, function (row) {
      if (row.getAttribute('data-ftp-gift-locked')) return;
      if ((row.textContent || '').indexOf('Welcome Kit') === -1) return;
      var qty = row.querySelector('[class*="quantity"]');
      if (!qty || qty.querySelector('[class*="quantity"]')) return;
      row.setAttribute('data-ftp-gift-locked', '1');
      qty.style.pointerEvents = 'none';
      qty.style.opacity = '0.45';
      var note = document.createElement('span');
      note.textContent = lastPes ? 'Free with the Power Endurance System subscription' : 'Free welcome game gift';
      note.style.cssText = 'display:block;font-size:.8em;opacity:.7;margin-top:4px;';
      qty.parentNode.insertBefore(note, qty.nextSibling);
    });
  }

  function start() {
    reconcileThenRefresh();
    if (window.MutationObserver) {
      var pending;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(lockUI, 200);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
